import { ReactNode } from 'react';

import {
  MultipleChoiceListCorrect,
  MultipleChoiceListIncorrect,
} from '../multiple-choice';
import * as Styled from './multiple-choice-radio.style';

type Props = JSX.IntrinsicElements['input'] & {
  label: ReactNode;
  checked?: boolean;
  disabled?: boolean;
  isCorrect?: boolean;
  isIncorrect?: boolean;
  isSelected?: boolean;
  onClick?: () => void;
};

const MultipleChoiceRadio = ({
  label,
  checked,
  disabled,
  isCorrect,
  isIncorrect,
  isSelected,
  onClick,
  ...inputProps
}: Props) => {
  const isCorrectAndNotSelected = !isSelected && isCorrect;
  const isIncorrectAndNotSelected = !isSelected && isIncorrect;
  return (
    <Styled.MultipleChoiceRadioInputLabel
      $disabled={disabled}
      htmlFor={inputProps.id}
    >
      <Styled.MultipleChoiceRadioInputFieldWrapper>
        <Styled.MultipleChoiceRadioInputField
          {...inputProps}
          checked={checked}
          disabled={disabled}
          type="radio"
          onChange={onClick}
        />
        {isCorrectAndNotSelected ? (
          <MultipleChoiceListCorrect />
        ) : isIncorrectAndNotSelected ? (
          <MultipleChoiceListIncorrect />
        ) : (
          <Styled.MultipleChoiceRadioInputDecor>
            <div />
          </Styled.MultipleChoiceRadioInputDecor>
        )}
      </Styled.MultipleChoiceRadioInputFieldWrapper>
      <Styled.MultipleChoiceRadioInputTextWrapper data-selector="radio-input-label">
        {label}
      </Styled.MultipleChoiceRadioInputTextWrapper>
    </Styled.MultipleChoiceRadioInputLabel>
  );
};

export default MultipleChoiceRadio;
